import { Box } from '@chakra-ui/react';
import { PriceStrategy } from '@snap-types/models/enums';
import { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import { BoxAlert } from '@ui/components/Alert';
import { supportsConfigurator } from '@ui/features/configurator/data';
import { useCurrentSiteCode } from '@ui/hooks/useCurrentSite';
import { useFormContext, useWatch } from 'react-hook-form';

export function ConfiguratorMissingPriceStrategyWarning() {
  const form = useFormContext<SnapSiteConfigEditFormDataUnvalidated>();
  const siteCode = useCurrentSiteCode();
  const configuratorSupported = supportsConfigurator(siteCode);

  const useConfigurator = useWatch({
    name: 'useConfigurator',
    control: form.control,
  });

  const priceStrategies = useWatch({
    name: 'priceStrategies',
    control: form.control,
  });

  if (!useConfigurator || !configuratorSupported) {
    return null;
  }

  const hasActiveNewPart = (priceStrategies ?? []).some(
    (strategy) =>
      strategy.priceStrategyType === PriceStrategy.NewPart && strategy.enabled,
  );

  if (hasActiveNewPart) {
    return null;
  }

  return (
    <Box mb={4}>
      <BoxAlert
        status="warning"
        title="Configure New Part won't be available"
        description="The Configurator is enabled, but the New Part price strategy isn't active. Configure New Part requires the Configurator to be enabled here AND New Part configured on the Price Strategies tab."
      />
    </Box>
  );
}
